import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./outline/screener.svg";
var ScreenerOutline_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  ScreenerOutline_default as default
};
